import { MultiRequestState } from "src/types";
import { v4 as uuid } from "uuid";

type State<T> = T & MultiRequestState;

const updatePending = <T>(state: State<T>, requestId: string): State<T> => ({
  ...state,
  pending: requestId,
  loading: true,
});

const updateSuccess = <T>(
  update: Partial<State<T>>,
  state: State<T>,
  requestId: string
): State<T> => {
  if (requestId === state.pending) {
    return { ...state, ...update, pending: null, loading: false };
  } else {
    return state;
  }
};

const updateFail = <T>(state: State<T>, requestId: string): State<T> => {
  if (requestId === state.pending) {
    return { ...state, pending: null, loading: false };
  } else {
    return state;
  }
};

const getRequestId = (): string => uuid();

export const multiRequest = {
  updateSuccess,
  updatePending,
  updateFail,
  getRequestId,
};



// WEBPACK FOOTER //
// ./src/models/utilities/multiRequestHandlers.ts